import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import TripadvancePaymentServices from "services/TripadvancePaymentServices";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";

import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import CommissionPaymentTable from "components/CommissionPayment/CommissionPaymentTable";
import CommissionPaymentServices from "services/CommssionPaymentServices";

// The A-P calculation columns (Selling Price ... Actual Amount) — everything
// else in the backend's headers array (ref_no/client_name/start_date/
// franchise_name/vendor_name/payment_status) already has its own fixed cell
// in this table, so only these are rendered dynamically.
const FORMULA_HEADER_KEYS = [
  "selling_price",
  "selling_gst",
  "selling_without_gst",
  "selling_tds",
  "selling_without_gst_tds",
  "bill_amount",
  "profit",
  "commission_with_gst",
  "commission_gst",
  "commission_without_gst",
  "commission_tds",
  "commission_owed",
];

const CommissionPayment = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(1);
  const [tripadvancepaymentData, setTripadvancePaymentData] = useState([]);
  const [reportHeaders, setReportHeaders] = useState([]);
  const [status, setStatus] = useState(false);
  const [error, setError] = useState(false);
  const [exportingData, setExportingData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const {
    tripadvancepaymentRef,
    dataTable,
    serviceData,
    handleSubmitTripadvancePayment,
    currentPage,
  } = useFilter(tripadvancepaymentData, itemsPerPage);
  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };
  useEffect(() => {
    const fetchCommissionPayment = async () => {
      setLoading(true);
      try {
        let response;
        if (tab === 1) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,
            type: 1,
          };
          response =
            await CommissionPaymentServices.getCommsionpayment(payload);
        } else if (tab === 2) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,
            type: 2,
            employee_id: id_employee,
          };
          response =
            await CommissionPaymentServices.getCommsionpayment(payload);
        } else if (tab === 3) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,
            type: 3,
          };
          response =
            await CommissionPaymentServices.getCommsionpayment(payload);
        }
        setStatus(response?.status);
        setTripadvancePaymentData(response?.data || []);
        setReportHeaders(response?.headers || []);
        setLoading(false);

        const finalData = response?.data?.map((item, index) => {
          return {
            "SI.No": index + 1,
            "Reference No": item.ref_no,
            "Client Name": item.client_name,
            "Start Date": item.start_date,
            "End Date": item.end_date,
            "Franchise Name": item.franchise_name || "-",
            Vendor: item.vendor_name || "-",
            "Selling Price": item.selling_price || "-",
            "Vendor Bill": item.bill_amount || "-",
            Profit: item.profit ?? "-",
            "Commission %": item.commission_percent || "-",
            "Commission Owed": item.commission_owed || "-",
            "Commission Paid": item.commission_paid || "-",
            "Commission Pending": item.commission_pending || "-",
            "Payment Status":
              Number(item.profit) <= 0 ? "Loss" : item.payment_status || "-",
          };
        });
        setExportingData(finalData);
      } catch (error) {
        setLoading(false);
        setError(true);
        console.error("Error fetching tripadvancepayment:", error);
      }
    };
    fetchCommissionPayment();
    setIsUpdate(false);
  }, [tab, isUpdate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue + 1);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "commisson payment" && perm.view === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "commisson payment" && perm.edit === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "commisson payment" && perm.export === 1,
      );

  const getTabName = () => {
    if (tab === 1) return "Unpaid";
    if (tab === 2) return "Paid";
    if (tab === 3) return "All";
    return "";
  };
  const filteredData = tripadvancepaymentData.filter((item) => {
    const search = searchText.toLowerCase();
    return (
      item.ref_no?.toLowerCase().includes(search) ||
      item.client_name?.toLowerCase().includes(search) ||
      item.franchise_name?.toLowerCase().includes(search) ||
      item.vendor_name?.toLowerCase().includes(search) ||
      item.payment_status?.toLowerCase().includes(search) ||
      String(item.commission_owed).includes(search) ||
      String(item.commission_paid).includes(search) ||
      String(item.commission_pending).includes(search)
    );
  });

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="From" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="To" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    placeholder="Quick Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                {hideExport && (
                  <ExportDataXlsx
                    title="Trip Advance List"
                    fileNames={`Commission ${getTabName()}`}
                    exportDataXlsx={exportingData}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}
                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab - 1}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unpaid"
            />
            =
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Paid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl. No.</TableCell>
                        <TableCell>Reference No.</TableCell>
                        <TableCell>Client Name</TableCell>
                        <TableCell>Travel Date</TableCell>
                        <TableCell>Franchise Name</TableCell>
                        <TableCell>Vendor Name</TableCell>
                        {/* Calculation columns rendered straight from the
                            backend's own headers (models/billPaymentModel.js's
                            getFranchiseCommissionPaymentList) so the labels/
                            formula notes shown here can never drift out of
                            sync with what's actually computed. */}
                        {reportHeaders
                          .filter((h) => FORMULA_HEADER_KEYS.includes(h.key))
                          .map((h) => (
                            <TableCell key={h.key}>
                              <p>{h.label}</p>
                              {h.formula && (
                                <p className="mb-0">{h.formula}</p>
                              )}
                            </TableCell>
                          ))}

                        <TableCell>
                          <p>Payment Status</p>

                        </TableCell>

                        {hideEdit && tab !== 2 && <TableCell>Action</TableCell>}
                      </tr>
                    </TableHeader>
                    <CommissionPaymentTable
                      tripadvancepayment={filteredData}
                      formulaKeys={FORMULA_HEADER_KEYS}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideEdit={hideEdit}
                      setIsUpdate={setIsUpdate}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no commission Payment." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default CommissionPayment;
